import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Table from 'components/Table';

import { addParamPageURL, getParamURL } from 'shared/utils/UrlUtil';
import { elipsis, formatDateTime } from 'shared/utils/StringUtil';
import moment from 'moment';
import auditRoute from '../../route';
import AuditFilter from './AuditList.filter';

import text from './AuditList.page.translation';

export class AuditList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNow: 1,
      selectedOption: [],
      selectedValue: [],
    };
  }

  componentDidMount() {
    this._getList(getParamURL('page'));
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (_.get(prevProps, 'location.search') !== _.get(location, 'search')) {
      this._getList(getParamURL('page'));
    }
  }

  _handleAPIFilter = pageValue => {
    const { selectedValue } = this.state;
    const {
      data: { refetch },
    } = this.props;

    const pageNum = pageValue || 1;
    const offset = (pageValue - 1) * 10;
    this.setState({ pageNow: pageNum }, () => {
      let where = {};
      selectedValue.forEach(item => {
        if (item.param === 'rangeDate') {
          where = {
            ...where,
            created_at: {
              _gte: moment(item.valParam[0]).format('YYYY-MM-DDTHH:mm:ss'),
            },
            _and: {
              created_at: {
                _lte: moment(item.valParam[1]).format('YYYY-MM-DDTHH:mm:ss'),
              },
            },
          };
        } else {
          where[item.param] = { _ilike: `%${item.valParam}%` };
        }
      });

      refetch({ offset, where });
    });
  };

  _getList = page => {
    const { selectedValue } = this.state;
    const {
      data: { refetch },
    } = this.props;

    const pageValue = parseInt(page, 10) || 1;
    if (selectedValue.length) {
      this._handleAPIFilter(pageValue);
    } else {
      const paramsAPI = {
        offset: (pageValue - 1) * 10,
      };
      this.setState({ pageNow: pageValue }, () => {
        refetch(paramsAPI);
      });
    }
  };

  _handleChangePage = page => {
    addParamPageURL(auditRoute.LIST, page, this.props.history);
    this._getList(page);
    this.setState({ pageNow: page });
  };

  _openEmployeeDetail = id => () => {
    this.props.history.push(auditRoute.DETAIL.replace(':id', id));
  };

  _renderEmployeeName = record => {
    const employeeName = _.get(record, 'employee_name', '');

    return (
      <button
        type="button"
        className="btn-details left-text"
        onClick={this._openEmployeeDetail(record.id)}
      >
        <Tooltip placement="topLeft" title={employeeName}>
          <span>{elipsis(employeeName, 30)}</span>
        </Tooltip>
      </button>
    );
  };

  _renderFormatedColumn = (format, item) => t => format(_.get(t, item));

  _renderNoColumn = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { pageNow } = this.state;
    if (pageNow === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (pageNow - 1) * 10;
    }
    return modifyIndex;
  };

  _tableColumns = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: 'No',
        key: 'index',
        width: 80,
        align: 'center',
        render: this._renderNoColumn,
      },
      {
        title: formatMessage(text.label.employee),
        key: 'employee_name',
        width: 200,
        render: this._renderEmployeeName,
      },
      {
        title: formatMessage(text.label.company),
        dataIndex: 'company_name',
        key: 'company_name',
        width: 160,
      },
      {
        title: formatMessage(text.label.date),
        render: this._renderFormatedColumn(formatDateTime, 'created_at'),
        key: 'created_at',
        width: 160,
      },
      {
        title: formatMessage(text.label.module),
        dataIndex: 'service',
        key: 'service',
        width: 120,
      },
      {
        title: formatMessage(text.label.action),
        dataIndex: 'operation_type',
        key: 'operation_type',
        width: 120,
      },
    ];
  };

  _getRowId = row => row.id;

  _handleUpdateState = (val, callback = () => null) => {
    this.setState(val, callback);
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">{formatMessage(text.home)}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{formatMessage(text.auditList)}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title topup-wrapper">
            {formatMessage(text.audit)}
          </span>
          <AuditFilter
            intl={this.props.intl}
            selectedValue={this.state.selectedValue}
            selectedOption={this.state.selectedOption}
            handleUpdateState={this._handleUpdateState}
            handleApiFilter={this._handleAPIFilter}
            handleChangePage={this._handleChangePage}
          />

          <Table
            rowID={this._getRowId}
            columns={this._tableColumns()}
            dataSource={_.get(this.props.data, 'custom_filter_audit', [])}
            pagination="true"
            currentPage={this.state.pageNow}
            rowClass="striped-table"
            totalItem={_.get(
              this.props.data,
              'custom_filter_audit_aggregate.aggregate.count',
              0,
            )}
            changePage={this._handleChangePage}
            loadingValue={_.get(this.props.data, 'loading', false)}
            scrollX={840}
          />
        </div>
      </div>
    );
  }
}

AuditList.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  intl: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default AuditList;
